/**
 * The Kitja mark — a kitchen ninja: a chef's toque over a masked hood.
 *
 * Inline rather than an <img> so it inherits crispness at any size and needs
 * no network request on the sign-in screen. `web/public/icon.svg` carries the
 * same shapes for the manifest, and `scripts/make-icons.py` rasterises them
 * for the places that cannot take SVG — the PWA icons and email.
 */
export function KitjaLogo({ size = 64 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      role="img"
      aria-label="Kitja"
      style={{ display: 'block' }}
    >
      <rect width="64" height="64" rx="14" fill="#1f6f4a" />
      <path d="M44 33.5c6 .5 10.5 3 14 7.5-5.5-1.5-10-1.5-14 .5z" fill="#154f36" />
      <path d="M44 38c5 1 8.5 3.5 11 7.5-4-2.5-7.5-3.5-11-3z" fill="#154f36" />
      <circle cx="23" cy="18" r="6.5" fill="#faf7f2" />
      <circle cx="32" cy="14.5" r="7.5" fill="#faf7f2" />
      <circle cx="41" cy="18" r="6.5" fill="#faf7f2" />
      <rect x="18.5" y="20" width="27" height="7.5" rx="2.5" fill="#faf7f2" />
      <path d="M20 28h24v10a12 12 0 0 1-24 0z" fill="#1d1b18" />
      <ellipse cx="27" cy="35.5" rx="3.1" ry="2.6" fill="#faf7f2" />
      <ellipse cx="37" cy="35.5" rx="3.1" ry="2.6" fill="#faf7f2" />
    </svg>
  );
}
